// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gorebyss: PokeData = {
  "id": 368,
  "name": "gorebyss",
  "height": 18,
  "weight": 226,
  "base_experience": 170,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "water-gun",
    "hydro-pump",
    "confusion",
    "psychic",
    "agility",
    "amnesia",
    "safeguard",
    "baton-pass",
    "rain-dance",
    "whirlpool",
    "dive",
    "iron-defense",
    "water-sport",
    "water-pulse",
    "aqua-ring",
    "aqua-tail",
    "captivate",
    "coil",
    "shell-smash",
    "draining-kiss"
  ],
  "moves": [
    "hydro-pump",
    "psychic",
    "agility",
    "rain-dance",
    "whirlpool",
    "iron-defense",
    "aqua-tail",
    "bubble-beam",
    "life-dew",
    "bubble",
    "liquidation",
    "aqua-jet",
    "aqua-cutter"
  ],
  "evolution_chain": {
    "id": 188,
    "item": null,
    "species": [
      {
        "name": "clamperl",
        "order": 396,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "huntail",
        "order": 397,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 366,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      },
      {
        "name": "gorebyss",
        "order": 398,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 366,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 122,
    "speed": 87,
    "ability_power": 191
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
